import {ModeSettingEnum} from '../../../../../shared/GameEnums'
import {BaseGameModeData, GameModeDataController} from '@colonist/shared-types'
import {RoomState} from '../../../../../shared/RoomState'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend'
import {UIMRoomGamemodeMapCardView} from './UIMRoomCardView'
import {TemporaryModeSettingEnum} from '@colonist/game-base-types'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {TranslationArrayKeys, TranslationObject} from '@colonist/i18n'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'

export class UIMRoomModeController {
    private readonly cardList: {modeData: BaseGameModeData, element: UIMRoomGamemodeMapCardView, isModeAccessible: boolean}[] = []

    isSelectedModeAccessible: boolean = true

    constructor(container: HTMLDivElement, roomState: RoomState) {
        this.createAllCards(container)
        this.update(roomState)
    }

    update(roomState: RoomState) {
        for(const card of this.cardList) {
            const isSelected = roomState.gameSetting.modeSetting == card.modeData.modeSetting
            card.element.setSelect(isSelected)
            if(isSelected) this.isSelectedModeAccessible = card.isModeAccessible
        }
    }

    private createAllCards(container: HTMLDivElement) {
        const allGameModeData = GameModeDataController.publicGameModeDataList
        for(const gameModeData of allGameModeData) {
            if(gameModeData.temporaryModeSetting == TemporaryModeSettingEnum.ServerStressTest) continue
            const isLocked = !ClientUserState.userState?.items.hasAccessToPremiumMode(gameModeData)
            const descriptionDiv = document.createElement('div')
            const gameModeInfoBody = UIMRoomModeController.getGameModeInfoBody(gameModeData)
            const text = UIMRoomModeController.createSingleMapInfo(clientI18n.tArray(gameModeInfoBody))
            const translatedMessage: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {
                value: text,
                interpolation: {
                    escapeValue: false,
                },
            }}
            setElementInnerHTML(descriptionDiv, translatedMessage)

            const updateGamemodeSocketCallback = () => SocketLobbySend.clickedRoomSettingUpdateGameModeSetting(String(ModeSettingEnum[gameModeData.modeSetting]))
            const card = new UIMRoomGamemodeMapCardView(container, gameModeData.name, gameModeData.icon, descriptionDiv, isLocked, updateGamemodeSocketCallback)
            this.cardList.push({modeData: gameModeData, element: card, isModeAccessible: !isLocked})
        }
    }

    private static createSingleMapInfo(body: string[]): string {
        let text = '<ul>'
        for(const element of body) {
            text += '<li>' + element
            text += '</li>'
        }
        text += '</ul>'
        return text
    }

    private static getGameModeInfoBody(gameModeData: BaseGameModeData): TranslationArrayKeys {
        switch(gameModeData.modeSetting) {
            case ModeSettingEnum.Classic4P: return 'strings:colonistCommon.gameModes.classic4P.body'
            case ModeSettingEnum.TutorialClassic4P:
            case ModeSettingEnum.BeginnerModeClassic4P: return 'strings:colonistCommon.gameModes.classicTutorial4P.body'
            case ModeSettingEnum.Classic56P: return 'strings:colonistCommon.gameModes.classic56P.body'
            case ModeSettingEnum.Classic78P: return 'strings:colonistCommon.gameModes.classic78P.body'
            case ModeSettingEnum.Seafarers4P: return 'strings:colonistCommon.gameModes.seafarers4P.body'
            case ModeSettingEnum.Seafarers56P: return 'strings:colonistCommon.gameModes.seafarers56P.body'
            case ModeSettingEnum.CitiesAndKnights4P: return 'strings:colonistCommon.gameModes.citiesAndKnights4P.body'
            case ModeSettingEnum.CitiesAndKnights56P: return 'strings:colonistCommon.gameModes.citiesAndKnights56P.body'
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P: return 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.body'
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P: return 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.body'
            case ModeSettingEnum.ServerStressTestClassic4P: return 'strings:colonistCommon.gameModes.serverStressTestClassic4P.body'
        }
    }
}
